import { makeStyles } from '@material-ui/core';

export const useNoDataStyles = makeStyles((theme) => ({
  box: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingTop: '180px',
    height: 'auto',
    alignItems: 'center',
    textAlign: 'center',
  },
  message: {
    marginTop: theme.spacing(2),
    maxWidth: '520px',
  },
  placeholderIcon: {
    userSelect: 'none',
    fontSize: '200px',
    color: theme.palette.grey[300],
  },
}));
